import { render, staticRenderFns } from "./ArchiveManager.vue?vue&type=template&id=079cb771&scoped=true&"
import script from "./ArchiveManager.vue?vue&type=script&lang=js&"
export * from "./ArchiveManager.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveManager.vue?vue&type=style&index=0&id=079cb771&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079cb771",
  null
  
)

export default component.exports